import getServerUrl from 'shared/helpers/getServerUrl';

// export const BASE_URL = 'https://dev.admin-test.bsg.world';
// export const BASE_URL = 'http://65.109.128.217:8000';
export const BASE_LIST_URL = '/tests/countries/custom';

export const BASE_URL = process.env.REACT_APP_BASEURL || getServerUrl() || '';
